import React from "react";
import Button from "web/react/components/button/button";
import classnames from "classnames";
import styles from "./multiply-on-hover-button.css";

interface MultiplyOnHoverButtonProps {
    className?: string;
    onClick: () => void;
    disabled: boolean;
    fullWidth: boolean;
    fullHeight: boolean;
    openInNewTab: boolean;
    children: JSX.Element | string;
}

export default function MultiplyOnHoverButton({
    className,
    onClick,
    disabled,
    fullWidth,
    fullHeight,
    openInNewTab,
    children,
}: MultiplyOnHoverButtonProps): JSX.Element {
    return (
        <Button
            styleType="primary"
            className={classnames(className, styles.buttonMultiply)}
            onClick={onClick}
            disabled={disabled}
            fullWidth={fullWidth}
            fullHeight={fullHeight}
            openInNewTab={openInNewTab}
        >
            <div className={classnames(styles.multiplyLabel, styles.topLabel)}>{children}</div>
            <div className={classnames(styles.multiplyLabel, styles.bottomLabel)}>{children}</div>
            <div className={classnames(styles.multiplyLabel, styles.centerLabel)}>{children}</div>
        </Button>
    );
}
